export default __webpack_public_path__ + "static/media/fidelitas_ing.a143d5b9.png";